export enum GENERAL_PERMISSIONS {
  canCreateAccount = 'CREATE_ACCOUNT',
  //TODO this permission is not used, implement it later
  //canClearAccount = 'CLEAR_ACCOUNT',
  canOpenCashDrawer = 'OPEN_CASH_DRAWER',
  canDepositInCashDrawer = 'CASH_DRAWER_DEPOSIT',
  canWithdrawInCashDrawer = 'CASH_DRAWER_WITHDRAWAL',
  canViewOpenAccounts = 'VIEW_OPEN_ACCOUNTS',
  canViewClosedAccounts = 'VIEW_CLOSED_ACCOUNTS',
  canViewOthersOpenAccounts = 'VIEW_OTHERS_OPEN_ACCOUNTS',
  canViewOthersClosedAccounts = 'VIEW_OTHERS_CLOSED_ACCOUNTS',
  canGenerateConsumptions = 'GENERATE_CONSUMPTIONS',
  canUnlinkDevice = 'UNLINK_DEVICE',
  canChangeLocation = 'CHANGE_BAR',
  canChangeCashDrawer = 'CHANGE_CASH_DRAWER',
  canSplitAccount = 'SPLIT_ACCOUNT',
  canEmptyAccount = 'EMPTY_ACCOUNT',
  canConfigurePaymentTerminals = 'CONFIGURE_PAYMENT_TERMINALS',
  canConfigurePrinters = 'CONFIGURE_PRINTERS',
}